import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { colorBgBase, colorBgSurface, space2, space32, space6, space12, colorTextMedium } = theme();

  return StyleSheet.create({
    button: {
      alignSelf: "flex-start",
    },
    description: {
      color: colorTextMedium,
      marginBottom: space6,
      maxWidth: 500,
    },
    fullWidth: {
      width: "100%",
    },
    halfWidth: {
      width: "50%",
    },
    image: {
      height: "100%",
      width: "100%",
    },
    imageContainer: {
      aspectRatio: 751 / 370,
      backgroundColor: colorBgSurface,
    },
    infoContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
    },
    infoContainerExtraLarge: {
      minHeight: 800,
    },
    infoContainerLarge: {
      minHeight: 600,
      paddingHorizontal: space32,
    },
    infoContainerMedium: {
      alignItems: "center",
    },
    infoContainerSmall: {
      backgroundColor: colorBgBase,
      padding: space6,
      paddingBottom: space12,
    },
    title: {
      marginBottom: space2,
    },
    wrapper: {
      backgroundColor: colorBgBase,
      display: "flex",
      flexDirection: "row",
      flex: 1,
      width: "100%",
    },
    wrapperSmall: {
      flexDirection: "column",
    },
  });
};

export { style };
